import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter, find, get, has, includes, orderBy } from 'lodash';
import Config from 'config';
import API from '../lib/tessitura/API';
import features from '../lib/common/features';
import arrayWrap from '../lib/common/arrayWrap';
import filterPastPerformances from 'lib/common/filterPastPerformances';
import { redirectWithError } from '../lib/common/fallbacks';
import { prepareColorCode } from 'lib/common/colorCode';

import SYOSContainer from './SYOSContainer';
import LevelBASelectorContainer from './LevelBASelectorContainer';
import LoadingSpinner from 'components/LoadingSpinner';

import { CONTEXT } from 'constants';
import Modal from '../components/Modal';

let config;

class AppContainer extends Component {
  constructor(props) {
    super(props);
    config = new Config().getConfig();

    /**
     * If we are provided the MOS and promo/source code
     * ahead of time we can pre-populate loginInfo
     */
    let loginInfo = null;
    if (this.props.initialMos && props.initialPromoCode) {
      loginInfo = {
        MOS: props.initialMos,
        promotion_code: props.initialPromoCode
      };
    }

    let currentFacility = find(config.facilityMapping, item => {
      return item.facility_no === props.facilityNo;
    });

    let sectionMapping = {};
    if (has(currentFacility, 'levelSelector.sectionMap')) {
      sectionMapping = currentFacility.levelSelector.sectionMap;
    }

    this.state = {
      loginInfo: loginInfo,
      maxTickets: null,
      currentFacility: currentFacility,
      usesGeneratedSeatmap: !currentFacility,
      detailsWithDiscounting: null,
      seatData: [],
      screenData: [],
      screenZoneData: null,
      details: null,
      prices: [],
      activePromoCode: null,
      selectedLevel: null,
      colours: [],
      selectedZone: undefined,
      sectionMapping: sectionMapping,
      performances: [],
      useSectionGraphic:
        currentFacility &&
        currentFacility.levelSelector &&
        currentFacility.levelSelector.sectionGraphic,
      currentContext: this.props.queryParams.syos
        ? CONTEXT.SEAT_SELECTION
        : CONTEXT.SECTION_SELECTION,
      groupSalesNoticeMessage: null,
      zoneNames: {},
      getCartPromise: null
    };

    this.getLoginInfo = this.getLoginInfo.bind(this);
    this.fetchCoreData = this.fetchCoreData.bind(this);
    this.onLevelSelected = this.onLevelSelected.bind(this);
    this.onChangePerformance = this.onChangePerformance.bind(this);
    this.onPromoCodeReady = this.onPromoCodeReady.bind(this);
    this.updateContext = this.updateContext.bind(this);
    this.updategroupSalesNotice = this.updategroupSalesNotice.bind(this);
    this.renderGroupSalesNotice = this.renderGroupSalesNotice.bind(this);
  }

  componentDidMount() {
    /* global __DEV__ */
    if (__DEV__) {
      features.logEnabledFeatures();
    }

    if (localStorage.getItem('sessionkey')) {
      localStorage.removeItem('sessionkey');
    }

    API.configure(this.props.endpoint, this.props.initialSessionKey);

    API.getSessionKey()
      .then(() => {
        Promise.all([this.getLoginInfo(), API.getMaxTicketAmount()]).then(
          results => {
            let [loginInfo, maxTickets] = results;

            this.setState({
              loginInfo: loginInfo,
              maxTickets: maxTickets
            });

            this.fetchCoreData(this.props.initialPerformanceId, loginInfo);
          },
          redirectWithError
        );
      })
      .catch(redirectWithError);

    if (config.features.levelBASelector.syosEnabled) {
      this.setState({
        getCartPromise: API.getCart()
      });
    }
  }

  getLoginInfo() {
    if (this.state.loginInfo) {
      return Promise.resolve(this.state.loginInfo);
    } else {
      return API.loginInfo();
    }
  }

  parseLookaheadData(result, priceToOverride) {
    if (!Array.isArray(result.PriceType)) {
      result.PriceType = [result.PriceType];
    }

    //Override allprice
    for (let newPriceIndex in priceToOverride) {
      priceToOverride[newPriceIndex].price_type = priceToOverride[
        newPriceIndex
      ].price_type
        .split(',')
        .map(pt => parseInt(pt));

      for (let oldPriceIndex in result.AllPrice) {
        if (
          parseInt(priceToOverride[newPriceIndex].zone_no) ===
            parseInt(result.AllPrice[oldPriceIndex].zone_no) &&
          includes(
            priceToOverride[newPriceIndex].price_type,
            parseInt(result.AllPrice[oldPriceIndex].price_type)
          )
        ) {
          result.AllPrice[oldPriceIndex].price =
            priceToOverride[newPriceIndex].final_price;
          result.AllPrice[oldPriceIndex].price_type_desc =
            priceToOverride[newPriceIndex].discount_price_type_desc;
          result.AllPrice[oldPriceIndex].description =
            priceToOverride[newPriceIndex].discount_price_type_desc;

          for (let priceTypeId in result.PriceType) {
            if (
              parseInt(result.AllPrice[oldPriceIndex].price_type) ===
              parseInt(result.PriceType[priceTypeId].price_type)
            ) {
              // result.PriceType[priceTypeId].price_type_desc =
              //   priceToOverride[newPriceIndex].discount_price_type_desc;
              // result.PriceType[priceTypeId].description =
              //   priceToOverride[newPriceIndex].discount_price_type_desc;
              //
              // if (priceToOverride[newPriceIndex].color_on_syos == 'Y') {
              //   result.PriceType[priceTypeId].category = 'Discount';
              // }
            }
          }

          if (priceToOverride[newPriceIndex].color_on_syos == 'Y') {
            result.AllPrice[oldPriceIndex].category = 'Discount';
          }
        }
      }
    }

    const enabledPrices = arrayWrap(result.PriceType).map(_ => _.price_type);
    return [
      result.PriceType,
      arrayWrap(result.AllPrice).filter(function(price) {
        return enabledPrices.indexOf(price.price_type) !== -1;
      })
    ];
  }

  fetchCoreData(performanceId, loginInfo) {
    this.props.initialPerformanceId = performanceId;

    API.getDetailsWithDiscounting(
      this.props.initialPerformanceId,
      this.props.packageNo,
      loginInfo.MOS,
      loginInfo.promotion_code
    ).then(result => {
      if (this.props.packageNo) {
        return API.getPkgPricingRuleLookahead(
          this.props.packageNo,
          loginInfo.MOS
        ).then(priceToOverride => {
          [result.PriceType, result.AllPrice] = this.parseLookaheadData(
            result,
            priceToOverride
          );

          let details = {
            summary:
              this.props.packageNo && result.Package
                ? result.Package
                : result.Performance,
            webContent: arrayWrap(result.WebContent)
          };

          let enabledPrices = arrayWrap(result.PriceType).map(
            _ => _.price_type
          );
          let prices = arrayWrap(result.AllPrice).filter(function(price) {
            return enabledPrices.indexOf(price.price_type) !== -1;
          });

          let colours = prepareColorCode(prices);

          let priceTypes = result.PriceType.reduce((acc, priceType) => {
            priceType.selected = false;
            priceType.highlighted = false;
            priceType.count = priceType.description === 'Standard' ? 2 : 0;
            acc.push(priceType);
            return acc;
          }, []);

          let zoneNames = {};
          priceTypes.forEach(priceType => {
            if (zoneNames[priceType.zone_no] === undefined) {
              zoneNames[priceType.zone_no] = priceType.zone_desc;
            }
          });

          this.setState({
            detailsWithDiscounting: result,
            details: details,
            prices: prices,
            colours: colours,
            priceTypes: priceTypes,
            zoneNames: zoneNames
          });

          API.getAllPerformances(
            this.state.details.summary.prod_season_no
          ).then(result => {
            let performance = get(result, 'Performance');
            if (!performance) {
              performance = get(result, 'result');
            }
            let performances = arrayWrap(performance);
            performances = orderBy(performances, ['perf_dt'], ['asc']);

            performances = filter(performances, performance => {
              return (
                performance.description ===
                this.state.details.summary.description
              );
            });

            if (performances.length) {
              this.setState({
                performances: filterPastPerformances(performances)
              });
            }
          });

          API.getSeatmapData(
            performanceId,
            this.props.packageNo,
            loginInfo.MOS,
            this.props.facilityNo,
            loginInfo.promotion_code,
            this.state.usesGeneratedSeatmap
          ).then(result => {
            this.setState({
              seatData: get(result, 'seatsResults'),
              screenData: get(result, 'screensResults.Screens'),
              screenZoneData: get(result, 'screenZoneData')
            });

            if (config.features.levelBASelector.syosEnabled) {
              this.state.getCartPromise.then(cartData => {
                let lineItems = [];
                if (this.props.packageNo > 0) {
                  lineItems = filter(cartData.PackageLineItem, item => {
                    return item.pkg_no === this.props.packageNo;
                  });
                } else {
                  lineItems = filter(cartData.LineItem, item => {
                    return item.perf_no === this.props.initialPerformanceId;
                  });
                }

                if (lineItems.length) {
                  this.updateContext(CONTEXT.SEAT_SELECTION);
                } else {
                  this.setState({
                    showLevelSelectMap: true
                  });
                }
              });
            } else {
              this.setState({
                showLevelSelectMap: true
              });
            }
          });
        });
      } else if (performanceId) {
        return API.getPerfPricingRuleLookahead(
          performanceId,
          loginInfo.MOS
        ).then(priceToOverride => {
          [result.PriceType, result.AllPrice] = this.parseLookaheadData(
            result,
            priceToOverride
          );

          let details = {
            summary:
              this.props.packageNo && result.Package
                ? result.Package
                : result.Performance,
            webContent: arrayWrap(result.WebContent)
          };

          let enabledPrices = arrayWrap(result.PriceType).map(
            _ => _.price_type
          );
          let prices = arrayWrap(result.AllPrice).filter(function(price) {
            return enabledPrices.indexOf(price.price_type) !== -1;
          });

          let colours = prepareColorCode(prices);

          let priceTypes = result.PriceType.reduce((acc, priceType) => {
            priceType.selected = false;
            priceType.highlighted = false;
            priceType.count = priceType.description === 'Standard' ? 2 : 0;
            acc.push(priceType);
            return acc;
          }, []);

          let zoneNames = {};
          priceTypes.forEach(priceType => {
            if (zoneNames[priceType.zone_no] === undefined) {
              zoneNames[priceType.zone_no] = priceType.zone_desc;
            }
          });

          this.setState({
            detailsWithDiscounting: result,
            details: details,
            prices: prices,
            colours: colours,
            priceTypes: priceTypes,
            zoneNames: zoneNames
          });

          API.getAllPerformances(
            this.state.details.summary.prod_season_no
          ).then(result => {
            let performance = get(result, 'Performance');
            if (!performance) {
              performance = get(result, 'result');
            }
            let performances = arrayWrap(performance);
            performances = orderBy(performances, ['perf_dt'], ['asc']);

            performances = filter(performances, performance => {
              return (
                performance.description ===
                this.state.details.summary.description
              );
            });

            if (performances.length) {
              this.setState({
                performances: filterPastPerformances(performances)
              });
            }
          });

          API.getSeatmapData(
            performanceId,
            this.props.packageNo,
            loginInfo.MOS,
            this.props.facilityNo,
            loginInfo.promotion_code,
            this.state.usesGeneratedSeatmap
          ).then(result => {
            this.setState({
              seatData: get(result, 'seatsResults'),
              screenData: get(result, 'screensResults.Screens'),
              screenZoneData: get(result, 'screenZoneData')
            });

            if (config.features.levelBASelector.syosEnabled) {
              this.state.getCartPromise.then(cartData => {
                let lineItems = [];
                if (this.props.packageNo > 0) {
                  lineItems = filter(cartData.PackageLineItem, item => {
                    return item.pkg_no === this.props.packageNo;
                  });
                } else {
                  lineItems = filter(cartData.LineItem, item => {
                    return item.perf_no === this.props.initialPerformanceId;
                  });
                }

                if (lineItems.length) {
                  this.updateContext(CONTEXT.SEAT_SELECTION);
                } else {
                  this.setState({
                    showLevelSelectMap: true
                  });
                }
              });
            } else {
              this.setState({
                showLevelSelectMap: true
              });
            }
          });
        });
      }
    });
  }

  onLevelSelected(selector, isGa, newZoom, extraParams, isEmbed) {
    const bestAvailableUrl = features.getOption(
      'levelSelector',
      'bestAvailableUrl'
    );

    const fullScreenUrl = features.getOption('levelSelector', 'fullScreenURL');
    if (isGa && bestAvailableUrl && this.props.initialPerformanceId) {
      if (extraParams) {
        window.location = `${bestAvailableUrl}${
          this.props.initialPerformanceId
        }?${extraParams}`;
      } else {
        window.location = `${bestAvailableUrl}${
          this.props.initialPerformanceId
        }`;
      }
    } else if (isEmbed && fullScreenUrl && this.props.initialPerformanceId) {
      window.location = `${fullScreenUrl}&layer=${selector}&perf_no=${
        this.props.initialPerformanceId
      }&facility_no=${this.props.facilityNo}${
        this.props.initialSessionKey
          ? `&session_key=${this.props.initialSessionKey}`
          : ''
      }${
        this.props.initialPromoCode
          ? `&source_code=${this.props.initialPromoCode}`
          : ''
      }`;
    } else {
      this.setState({
        selectedLevel: {
          selector: selector,
          newZoom: newZoom
        }
      });
    }
  }

  onChangePerformance(performanceId) {
    this.setState({
      details: null,
      prices: [],
      seatData: [],
      screenData: []
    });

    this.fetchCoreData(performanceId, this.state.loginInfo);
  }

  onPromoCodeReady(activePromoCode) {
    if (activePromoCode) {
      this.setState({
        activePromoCode: activePromoCode
      });
    }
  }

  updateContext(newContext, resetSelectedSectionData = false) {
    let detailsToUpdate = {
      currentContext: newContext,
      showLevelSelectMap: true,
      getCartPromise: null
    };

    if (resetSelectedSectionData) {
      let priceTypes = this.state.priceTypes;
      priceTypes = priceTypes.reduce((acc, priceType) => {
        priceType.selected = false;
        priceType.highlighted = false;
        acc.push(priceType);
        return acc;
      }, []);

      detailsToUpdate.selectedZone = null;
      detailsToUpdate.priceTypes = priceTypes;
    }

    this.setState(detailsToUpdate);
  }

  updategroupSalesNotice(status = null) {
    this.setState({
      groupSalesNoticeMessage: status
    });
  }

  renderGroupSalesNotice() {
    if (this.state.groupSalesNoticeMessage) {
      config = new Config().getConfig();
      return (
        <Modal
          closeOnOutsideClick={false}
          onClose={() => {
            this.setState({
              groupSalesNoticeMessage: null
            });
          }}
        >
          <div className="syos-enhanced-notice">
            <div
              className="syos-enhanced-notice__inner"
              dangerouslySetInnerHTML={{
                __html: config.maxTicketsMessage
              }}
            />
          </div>
        </Modal>
      );
    } else {
      return null;
    }
  }

  render() {
    const levelSelectorConfig = get(
      this.state.currentFacility,
      'levelSelector'
    );

    if (this.state.currentContext === CONTEXT.SECTION_SELECTION) {
      return this.state.loginInfo &&
        this.state.priceTypes &&
        this.state.showLevelSelectMap &&
        this.state.performances ? (
        <LevelBASelectorContainer
          initialPerformanceId={this.props.initialPerformanceId}
          initialPackageNo={this.props.packageNo}
          details={this.state.details}
          levelSelectorConfig={levelSelectorConfig}
          priceTypes={this.state.priceTypes}
          selectedZone={this.state.selectedZone}
          sectionMapping={this.state.sectionMapping}
          performances={this.state.performances}
          loginInfo={this.state.loginInfo}
          seatData={this.state.seatData}
          onPromoCodeReady={this.onPromoCodeReady}
          useSectionGraphic={this.state.useSectionGraphic}
          updateContext={this.updateContext}
          onComplete={this.props.onComplete}
          updategroupSalesNotice={this.updategroupSalesNotice}
          renderGroupSalesNotice={this.renderGroupSalesNotice}
          maxTickets={this.state.maxTickets}
        />
      ) : (
        <LoadingSpinner isActive={!this.state.showLevelSelectMap} />
      );
    } else {
      return this.state.loginInfo ? (
        <SYOSContainer
          initialPerformanceId={this.props.initialPerformanceId}
          packageNo={this.props.packageNo}
          maxTickets={this.state.maxTickets}
          loginInfo={this.state.loginInfo}
          details={this.state.details}
          prices={this.state.prices}
          priceTypes={this.state.priceTypes}
          seatData={this.state.seatData}
          screenData={this.state.screenData}
          screenZoneData={this.state.screenZoneData}
          selectedLevel={this.state.selectedLevel}
          currentFacility={this.state.currentFacility}
          usesGeneratedSeatmap={this.state.usesGeneratedSeatmap}
          activePromoCode={this.state.activePromoCode}
          onChangePerformance={this.onChangePerformance}
          onPromoCodeReady={this.onPromoCodeReady}
          onComplete={this.props.onComplete}
          colours={this.state.colours}
          updateContext={this.updateContext}
          updategroupSalesNotice={this.updategroupSalesNotice}
          renderGroupSalesNotice={this.renderGroupSalesNotice}
          zoneNames={this.state.zoneNames}
          getCartPromise={this.state.getCartPromise}
        />
      ) : null;
    }
  }
}

AppContainer.propTypes = {
  endpoint: PropTypes.string.isRequired,
  onComplete: PropTypes.func.isRequired,
  initialSessionKey: PropTypes.string,
  initialPerformanceId: PropTypes.number.isRequired,
  initialMos: PropTypes.number,
  initialPromoCode: PropTypes.number,
  packageNo: PropTypes.number,
  facilityNo: PropTypes.number,
  queryParams: PropTypes.object
};

export default AppContainer;



// WEBPACK FOOTER //
// ./src/javascripts/containers/AppContainer.js